import { createActions, createReducer } from "reduxsauce";

export const { Types, Creators } = createActions({
    setLogo: ["payload"],
});

const INITIAL_STATE = {};

const setLogo = (state = INITIAL_STATE, action) => ({
    ...state,
    image: action.payload,
});

export default createReducer(INITIAL_STATE, {
    [Types.SET_LOGO]: setLogo,
});
